import { useQuery } from '@tanstack/react-query';
import { HcpGroup } from '@ixicare/resources';

// Shared HCP-groups query so the key shape, queryFn, and enabled gate stay
// consistent across consumers. `staleTime` is opt-in: read-only views (alert
// logs) can keep names cached, while the assignment tabs rely on the default
// (0) so refetch-on-remount reflects fresh assignments.
export function useHcpGroups(siteUuid?: string, options?: { staleTime?: number }) {
  return useQuery({
    queryKey: ['hcpGroups', siteUuid],
    queryFn: () => HcpGroup.getHcpGroups({ siteUuid }),
    enabled: !!siteUuid,
    staleTime: options?.staleTime,
  });
}
